import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Modal from "react-bootstrap/Modal";
import { SilModal } from "./SilModal";

export interface Props {
  message: string;
  onClose: () => void;
}

export default class SaveFailedModal extends React.Component<Props, {}> {
  render() {
    const message = this.props.message;
    
    return (
      <SilModal closeModal={this.props.onClose} title="Silsolver" >
        <div>
          {message != null ?
            <React.Fragment>
                    <p>
                      {message}
                    </p>
            </React.Fragment>
            : ''}
          <div className="warning-footer ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
            <div className="left-div"></div>
            <div className="buttons">
              <button onClick={this.props.onClose}> Ok </button>
            </div>
          </div>
        </div>
      </SilModal>
    );
  }
}